import { Injectable } from '@angular/core';
import {throwError, Subject, ObservableInput, from, pipe, Observer, observable} from 'rxjs';
import { HistoricalData } from './models';
import {catchError, map, mapTo} from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, merge} from 'rxjs';
// import AWS object without services
import * as AWS from 'aws-sdk/global';
// import * as defaultProvider from '@aws-sdk/credential-provider-node';
// import individual service
import * as DynamoDB from 'aws-sdk/clients/dynamodb';
import { environment } from '../../environments/environment';
/*import _ from 'underscore';
const underScoreDebug = _;*/
const _ = require('underscore');
import * as moment from 'moment';
import 'moment/locale/ru';
// import * as dotenv from 'dotenv';
// require('dotenv').config();
import awsconfig from '../../aws-exports';
import {DocumentClient} from 'aws-sdk/lib/dynamodb/document_client';
import Amplify, {Auth, Hub} from 'aws-amplify';
import {AuthService} from '../auth/auth.service';
import {booleanObjectType} from 'aws-sdk/clients/iam';
import DeleteItemInput = DocumentClient.DeleteItemInput;
import Key = DocumentClient.Key;

@Injectable({
  providedIn: 'root'
})
export class CalendarDataService {
  /*public historicalData: Subject<HistoricalData[]> = new Subject();
  public selectedSubject: Subject<string> = new Subject();*/
  identityAuthorized = false;
  docClient: DocumentClient; // DynamoDB.DocumentClient;
  private userids = ['botium']; // development testing botid
    // forwardPage: event.queryStringParameters??null
/*  constructor(private http: HttpClient) { }
  public callDynamoDB(): Observable<any> {
    return this.http.get<any>('https://jsonplaceholder.typicode.com/posts/1');
  }*/
  public dynamoDataObservers$ = new Subject();
  public dynamoData$: any;
  public dynamoObservers = [];
  constructor(public authService: AuthService) {
    // const awsCredProvider = defaultProvider();
    AWS.config.update({
      region: awsconfig.aws_project_region,
      apiVersions: {
        dynamodb: '2012-08-10',
        // other service API versions
      },
      // credentialProvider: awsCredProvider,
      // credentials: this.authService.awsConfigCognitoCredentials
      /*{
        accessKeyId: 'AKIATN7ZUS2CT4VRMROO',
        secretAccessKey: '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'
      }*/}
    );
    // dotenv.config();
/*    const identityAuthorizedObserver = {
      next: (arr) => {
        console.log(arr);
        // this.zone.run(() => {this.response =  x.toString(); });
        this.identityAuthorized = true;
      },
      error: ( err ) => {
        console.log(err);
      },
      complete: () => {
        console.log('ALC. all items received fromm DynamoDB are processed now');
      }
    };
    this.authService.identityAuthorizedSubject$.subscribe(identityAuthorizedObserver);*/
    // this.docClient = new DynamoDB.DocumentClient();
  }
  private mapItems = map((x: DocumentClient.QueryOutput) =>
    x.Items);
  private processItem = map(arr => {
    return _.map(arr, (v) => this.processDynamoDoc(v));
  });
  private pipeItems = pipe(
    this.mapItems,
    this.processItem
  );
  private getQParams = (userid: string, fromTime: moment.Moment): DocumentClient.QueryInput => {
    const qParams  = {
      TableName : environment.EVENTS_TABLE_NAME,
      IndexName: 'userId-updated',
      // "Consistent reads are not supported on global secondary indexes"
      // tslint:disable-next-line:max-line-length
      // ConsistentRead: true, //ALC. Not default(false) all of the write operations that completed before the Scan began are guaranteed to be contained in the Scan response.
      KeyConditionExpression: 'userId = :v AND updated <= :fromTime',
      ReturnConsumedCapacity: 'INDEXES',
      ExpressionAttributeValues :
        {':fromTime' : fromTime.toISOString(),
          ':v': userid},
      ScanIndexForward: false,
      Limit: 20
      // forwardPage: event.queryStringParameters??null
    };
    return qParams;
  }

  public addUser(u: string): void{
    this.userids.push(u);
  }
  public callDynamoDB(): Observable<any> {
    const awsConfigDebug = AWS.config;
    const mapObservables = map((v: string) => {
      const q = this.getQParams(v, moment());
      const r = this.pipeItems(from(this.docClient
        .query(q)
        .promise()));
      // collect observables for debugging
/*      r.subscribe((observable: Observable<any>) => {
        console.log(observable);
        const observer: Observer<any> = {
          next: (data) => {
            console.log(data);
          },
          error: (err) => {
            console.log(err);
          },
          complete: () => {
            console.log('complete');
          }
        };
        this.dynamoObservers.push({v: observer});
        observable.subscribe(observer);
      });*/
      return r;
    });
    const ret = mapObservables(from(this.userids));
    this.dynamoDataObservers$.next(ret);
    this.dynamoDataObservers$.subscribe((obs: Observable<any>) => {
      console.log(obs);
      obs.subscribe((data) => {
        console.log(data);
      });
    });
    return ret; // this.pipeItems(from(qPromises)); // .pipe(x => this.processDynamoDoc(x));
  }
  public processDynamoDoc(item: any): any {
    const ret = {};
    const ticketNumber = item.ticketNumber;
    const startDate = item.event.ticket.timeFrom ?? item.updated;
    const endDateTimeStamp = (new Date(item.event.ticket.timeDue)).valueOf() ?? (new Date(startDate)).valueOf() + 59 * 60;
    const roomNumber = item.event.ticket.roomNumber;
    const appId = item.id; // + (new Date(startDate)).getUTCSeconds();
    const subjectId = `Ticket # ${ticketNumber} `;
    _.extend(ret, {
      id: appId,
      description: `Initiated by ${(item.userId ?? 'undefined')}`,
      location: `location ${roomNumber}0`,
      subject: subjectId,
      calendar: 'Room ' + roomNumber,
      start: new Date(startDate),
      end: new Date(endDateTimeStamp)
    });
    return ret;
  }
  getCalendarDataSubject(): Observable<any> {
    return this.callDynamoDB();
  }

  deleteAppointment(id: string): Observable<any>{
    // const key: Key = {id};
    const qParams: DeleteItemInput  = {
      TableName : environment.EVENTS_TABLE_NAME,
      // "Consistent reads are not supported on global secondary indexes"
      // tslint:disable-next-line:max-line-length
      // ConsistentRead: true, //ALC. Not default(false) all of the write operations that completed before the Scan began are guaranteed to be contained in the Scan response.
      Key: {id},
      ReturnConsumedCapacity: 'INDEXES'
      // forwardPage: event.queryStringParameters??null
    };
    return from(this.docClient.delete(qParams).promise());
  }
/*  handleError(error: HttpErrorResponse): ObservableInput<HttpErrorResponse>{
    console.log( 'error' , error);
    // return an observable with a user-facing error message
    return throwError ('Internal Error.');
  }
  getStaticData(selected: string): void {
    const url = `https://jsonplaceholder.typicode.com/posts/${selected}`;
    this.http.get<any>(url, {})
      .pipe(
        catchError((e) => {
          return this.handleError(e);
        })
      ).subscribe((response) => {
      console.log( 'calling historicalData.next ');
      this.historicalData.next(response as (HistoricalData[]));
    });
  }*/
}
